interface SingleSelectCardsProps {
  options: string[];
  selected: string | null;
  onChange: (selected: string) => void;
}

export default function SingleSelectCards({ options, selected, onChange }: SingleSelectCardsProps) {
  return (
    <div className="flex flex-col gap-2.5">
      {options.map((option) => {
        const isSelected = selected === option;
        return (
          <button
            key={option}
            type="button"
            onClick={() => onChange(option)}
            className={`w-full text-left px-5 py-3.5 rounded-xl border-2 text-sm font-medium transition-all duration-200 min-h-[48px] cursor-pointer ${
              isSelected
                ? 'border-coral bg-coral-light text-text-primary'
                : 'border-border-color bg-white text-text-secondary hover:border-coral/40'
            }`}
          >
            {option}
          </button>
        );
      })}
    </div>
  );
}